// 字段类型
export enum FieldTypeEnum {
  STRING = 'string',
  INT = 'int',
  DATE = 'date',
  OPTION = 'drop down',
}

/** 提交表单 - 选项Item */
export type OptionNameItemType = {
  value: string;
  isEdit: boolean;
  isDel: boolean;
};

/** 提交表单 */
export type FormDataType = {
  id: string;
  name?: string;
  type: string;
  isShow?: boolean;
  isEdit?: boolean;
  isDel?: boolean;
  optionName?: OptionNameItemType[];
};

// 联系人固定字段
export enum FixedFieldEnum {
  /** 邮箱 */
  Email = 'Email',
  Contacts = 'Contacts',
  /** 多渠道联系人 */
  MultiChannelContacts = 'Multi-channel contacts',
  /** 订阅状态 */
  SubscriptionStatus = 'Subscription status',
  /** 偏好 */
  Preference = 'Preference',
  /** 用户评级 */
  EngagementRating = 'Engagement rating',
  /** 语言 */
  Language = 'Language',
  /** 地点 */
  Location = 'Location',
  /** 标签 */
  Tag = 'Tag',
  /** 来源 */
  Source = 'Source',
  /** 添加时间 */
  AddDate = 'Add date',
  /** 上次修改时间 */
  LastChanged = 'Last changed',
  /** WhatsApp */
  WhatsApp = 'WhatsApp',
  /** Discord */
  Discord = 'Discord',
  /** Steam */
  Steam = 'Steam',
  /** 愿望清单 */
  WishList = 'Wish List',
  /** 游戏时长 */
  playTime = 'Playtime',
}

// 联系人固定字段 - 中文名称
export enum FixedFieldZhEnum {
  /** 邮箱 */
  Email = '邮箱',
  /** 订阅状态 */
  SubscriptionStatus = '订阅状态',
  /** 偏好 */
  Preference = '偏好',
  /** 用户评级 */
  EngagementRating = '用户评级',
  /** 语言 */
  Language = '语言',
  /** 地点 */
  Location = '地点',
  /** 标签 */
  Tag = '标签',
  /** 来源 */
  Source = '来源',
  /** 添加时间 */
  AddDate = '添加日期',
  /** 上次修改时间 */
  LastChanged = '上次修改',
  /** WhatsApp */
  WhatsApp = 'WhatsApp',
  /** Discord */
  Discord = 'Discord',
  /** Steam */
  Steam = 'Steam',
}

// 字段分类
export enum SystemEnum {
  /** 系统字段 */
  SYSTEM = 'system',
  /** 自定义字段 */
  EXTRA = 'extra',
  /** 偏好 */
  PREFERENCE = 'preference',
}

// 是否展示全部功能类型字段
export enum FieldResTypeEnum {
  /** 全部attribute */
  ALL = 1,
  /** 过滤掉内置类型attribute */
  FILTER_OUT_BUILT_IN = 0,
}

// 自定义字段 - 功能类型类型
export enum FieldFunctionalTypeEnum {
  /** 常规类型 */
  CONVENTIONAL_TYPE = 1,
  /** 内置类型 */
  BUILT_IN_TYPE = 2,
}
